import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"
import styled from "styled-components"
import {CopyOutlined} from "@ant-design/icons";

export function getColumns(onEdit, onDelete, onCrateDuplicate) {
  return [
    {
      width: 100,
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      width: 150,
      title: "Название",
      dataIndex: "nameRu",
      key: "nameRU",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Продукты",
      dataIndex: "productsView",
      key: "productsView",
      render: (data) =>
          data.map((item, i) => (
              <StyledTag key={`product_tag_${i}`} color={"default"} >
                {item}
              </StyledTag>
          )),
    },
    {
      width: 100,
      title: "Включен",
      dataIndex: "isActive",
      key: "isActive",
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      width: 100,
      title: "Дибликат категории",
      dataIndex: "duplicateCategoryName",
      key: "duplicateCategoryName",
      render: (text) => {
          const isDuplicate = text !== "Оригинальная категория"
          return (
              <StyledTag color={isDuplicate ? "rgb(56, 142, 60)" : "default"}>
                {text}
              </StyledTag>
          )
      },
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
              <Popconfirm
                placement="left"
                title="Действительно хотите удалить?"
                onConfirm={() => onDelete(record.id)}
                onCancel={() => stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <TrashSvg />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
          {/*{!record.duplicateCategory && (
            <Tooltip placement="top" title="Cоздать дубль" mouseLeaveDelay={0}>
              <Popconfirm
                  placement="left"
                  title={`Действительно хотите создать дубль от ${record.nameRu}?`}
                  onConfirm={() => onCrateDuplicate(record.id)}
                  onCancel={() => stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <CopyOutlined style={{ fontSize: "16px" }}/>
                </Button>
              </Popconfirm>
            </Tooltip>
          )}*/}
        </Space>
      ),
    }] : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`
